import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Typography,
} from "@mui/material";
import React, { useMemo } from "react";
import { projectTypes } from "../../../utils/main.ts";

export default function Description({
  project,
}: {
  project: ProjectContextType;
}) {
  const startDate = project.startDate?.toDateString();
  const endDate = project.endDate?.toDateString();
  const description = useMemo(() => {
    if (!project || !project.devices) {
      return [];
    }
    return project.devices.map((device) => `${device.description}`);
  }, [project]);

  return (
    <Card className="description-box">
      <CardHeader
        className={"description-card-header"}
        title={
          <Typography className={"header-title"}>
            Project Information
          </Typography>
        }
      />
      {!(project && project.id) ? (
        <Skeleton
          className="description-card-content-skeleton"
          animation="wave"
        />
      ) : (
        <CardContent className={"description-card-content"}>
          <Typography variant="body1">{project.name}</Typography>
          {project.type === projectTypes.device && (
            <Typography variant="body1">{description.join(", ")}</Typography>
          )}
          <Typography variant="body1">{`Data from ${startDate} - ${endDate}`}</Typography>
        </CardContent>
      )}
    </Card>
  );
}
